/*
  Twee dingen voor de toekomstige cart-abandonment-flow in Klaviyo:
  1) Stuurt een 'Added to Cart' event zodra het winkelwagenaantal stijgt.
  2) Houdt de 'bewaar winkelwagen'-prompt zichtbaar en werkend, ook nadat
     de winkelwagenlade opnieuw gerenderd wordt (bv. bij aantal wijzigen) —
     die re-render vervangt de DOM-node via innerHTML, dus een inline
     <script> in de snippet zelf zou daarna niet meer uitvoeren. Daarom
     staat alle logica hier, in een los bestand dat maar één keer laadt.
*/
(function () {
  var STORAGE_KEY = 'wsl_cart_email_captured';
  var wslLastItemCount = null;

  function wslFetchCart() {
    return fetch('/cart.js').then(function (response) {
      return response.json();
    });
  }

  function wslTrackAddedToCart() {
    wslFetchCart()
      .then(function (cart) {
        var count = cart.item_count;
        if (wslLastItemCount !== null && count > wslLastItemCount && window.klaviyo) {
          window.klaviyo.track('Added to Cart', {
            $value: cart.total_price / 100,
            ItemNames: cart.items.map(function (item) {
              return item.product_title;
            }),
          });
        }
        wslLastItemCount = count;
      })
      .catch(function () {});
  }

  function wslCaptured() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function wslSyncSaveEmailPrompt() {
    var wrapper = document.getElementById('WslCartSaveEmail');
    if (!wrapper) return;
    var form = document.getElementById('WslCartSaveEmailForm');
    if (wslCaptured()) {
      wrapper.hidden = true;
      return;
    }
    wrapper.hidden = false;
    if (form) form.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'WslCartSaveEmailForm') return;
    e.preventDefault();
    var form = e.target;
    var input = document.getElementById('WslCartSaveEmailInput');
    var status = document.getElementById('WslCartSaveEmailStatus');
    var email = input ? input.value.trim() : '';
    if (!email || !window.klaviyo) return;
    window.klaviyo
      .identify({ email: email })
      .then(function () {
        try {
          window.localStorage.setItem(STORAGE_KEY, '1');
        } catch (err) {}
        if (status) status.textContent = 'Bewaard — bedankt.';
        form.hidden = true;
      })
      .catch(function () {
        if (status) status.textContent = 'Er ging iets mis, probeer het later opnieuw.';
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    wslFetchCart()
      .then(function (cart) {
        wslLastItemCount = cart.item_count;
      })
      .catch(function () {});

    wslSyncSaveEmailPrompt();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        wslTrackAddedToCart();
        wslSyncSaveEmailPrompt();
      });
    }
  });
})();
